import React from 'react';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { Link } from '../Link/index';
import { Image } from '../../Media';
import { FreeShippingCaption } from '../../../Utils/FreeShippingCaption/freeShippingCaption';
import {
  PromoThreshold1,
  PromoThreshold2,
} from '../../../Utils/PromoThreshold/promoThreshold';
import { Component } from '../../../Contentful/component';
import { Button } from '..';

export const getContentType = (node) => {
  const contentType =
    node.data?.target?.__typename ||
    node.data?.target?.internal?.type ||
    node.data?.target?.sys?.type;
  return contentType;
};

export const marks = {
  [MARKS.BOLD]: (text) => <strong className='text-medium'>{text}</strong>,
};

export const nodes = {
  [BLOCKS.HEADING_1]: (node, children) => (
    <div className='my-4'>
      <Label
        type='h1'
        size='7xl'
        text={children}
      />
    </div>
  ),
  [BLOCKS.HEADING_2]: (node, children) => (
    <div className='my-4'>
      <Label
        type='h2'
        size='4xl'
        text={children}
      />
    </div>
  ),
  [BLOCKS.HEADING_3]: (node, children) => (
    <div className='my-4'>
      <Label
        type='h3'
        size='2xl'
        text={children}
      />
    </div>
  ),
  [BLOCKS.HEADING_4]: (node, children) => (
    <Label
      type='h4'
      size='xl'
      text={children}
    />
  ),
  [BLOCKS.HEADING_5]: (node, children) => (
    <Label
      type='h5'
      size=' xl'
      text={children}
    />
  ),
  [BLOCKS.HEADING_6]: (node, children) => (
    <Label
      type='h6'
      size='lg'
      text={children}
    />
  ),
  [BLOCKS.PARAGRAPH]: (node, children) => {
    // Handle line breaks
    if (children?.filter((e) => !!e).length === 0) {
      return <br />;
    }

    return (
      <Label
        type='p'
        family='font-inter'
        text={children}
        weight='light'
      />
    );
  },

  [BLOCKS.UL_LIST]: ({ content }) => (
    <ul className='list-disc my-2'>
      {content?.map((cont) =>
        cont.content.map((c) => (
          <li className='ml-5'>
            <Label
              type='p'
              family='font-inter'
              weight='light'
              text={c.content[0].value}
            />
          </li>
        ))
      )}
    </ul>
  ),

  [BLOCKS.HR]: () => <div className='w-1/5 border-2 border-white' />,

  [BLOCKS.EMBEDDED_ENTRY]: (node) => {
    const contentType = getContentType(node);

    if (node?.data?.target?.path) {
      return <Component {...node?.data?.target} />;
    }

    if (contentType === 'ContentfulButton') {
      return (
        <Button
          {...node?.data?.target}
          size='base'
          type='contained'
          color={{ classname: 'primary' }}
        />
      );
    }

    if (contentType === 'ContentfulIcon') {
      return <Icon {...node?.data?.target} />;
    }

    if (contentType === 'ContentfulLabel') {
      return <Label {...node?.data?.target} />;
    }

    if (contentType === 'ContentfulImage') {
      return <Image {...node?.data?.target} />;
    }

    if (contentType === 'ContentfulLink') {
      return <Link {...node?.data?.target} />;
    }
  },
  [INLINES.EMBEDDED_ENTRY]: (node) => {
    const contentType = getContentType(node);

    if (node.data?.target.key === 'FreeShippingCaption') {
      return <FreeShippingCaption />;
    }

    if (node.data?.target.key === 'PromoThreshold1') {
      return <PromoThreshold1 />;
    }

    if (node.data?.target.key === 'PromoThreshold2') {
      return <PromoThreshold2 />;
    }

    if (contentType === 'ContentfulLabel') {
      return <Label {...node?.data?.target} />;
    }
  },
};
